export const colors = {
  //grey
  lightGrey: "#EAECF0",
  silverGrey: "#EEEEEE",
  mediumGrey: "#475467",
  grey: "#344054",
  greyLight: "#787878",
  darkGrey: "#D0D5DD",
  inactiveGrey: "#667085",
  greyNeutral: "#6C737F",
  veryLightGrey: "#F2F4F7",
  inactiveLightGrey: "#1D2939",
  paleGrey: "#98A2B3",
  borderGrey: "#E6E6E6",
  shadowGrey: "#1018280F",
  shadowLightGrey: "#1018280D",
  grayBlue50: "#F8F9FC",
  grayBlue600: "#3E4784",
  grayBlue700: "#363F72",
  grayBlue: "#404968",
  darkerGrey: "#353535",
  gray25: "#FCFCFD",
  gray50: "#FAFAFA",
  gray100: "#F2F4F7",
  gray200: "#E9EAEB",
  gray300: "#8E8E8E",
  gray400: "#A4A7AE",
  gray500: "#717680",
  gray600: "#EFEFEF",
  gray700: "#414651",
  gray800: "#1D2939",
  gray900: "#181D27",
  primary100Grey: "#DDDDDD",
  primary500Grey: "#575757",
  choiceGray600: "#535862",
  choiceIconGray: "#A4A7AE",
  choiceTextGray: "#717680",
  choiceGray100: "#FDFDFD",
  choiceGray200: "#F5F5F5",
  choiceGray900: "#181D27",

  //blue
  paleBlue: "#CCE4F6",
  lightBlue: "#E6F2FB",
  veryLightBlue: "#EEF4FF",
  mediumBlue2: "#3538CD",
  mediumBlue: "#F2F8FD",
  darkBlue: "#0860C4",
  whiteBlue: "#F9FCFE",
  babyBlue: "#B3D7F2",
  turquoiseBlue: "#1570EF",
  primary25UC: "#F6F6F6",
  primary25AS: "#F5F9FD",
  primary100Blue: "#CEDFF3",
  primary200Blue: "#ADCAEB",
  primary300Blue: "#84B0E2",
  primary400Blue: "#5A95D8",
  primary500Blue: "#0860C4",
  primary600Blue: "#0860C4",
  primary700Blue: "#0860C4",
  primary50Blue: "#F5FAFF",
  primary25Blue: "#F5F9FD",
  primaryHover: "#064D9F",
  blueLight50: "#F0F9FF",
  blueLight25: "#F5FAFF",
  blueLight700: "#026AA2",
  blue100: "#D1E9FF",
  blue900: "#194185",
  blue700: "#175CD3",
  aquaBlue: "#E0EAFF",
  aquaBlue2: "#D3E3F1",
  veryDarkBlue: "#0B2343",
  hoverBlue: "#0B1339",
  hoverAS: "#054687",
  blueAS: "#0074C8",
  carouselBlue:"#717BBC",
  primaryBlue700:"#0060A8",
  primary75Blue:"#CEE0F3",
  darkBlue2:"#0961C4",
  disabledAS: "rgba(0, 116, 200, 0.20)",
  darkBlue3: "#0b1f66",
  deltaDarkBlue: "#697180",
  borderBlue: "#006CBD",
  disabledAC: "#00507866",

  //
  boralaOrange: "#FFC72C",
  boralaOrangeHover: "#FFC013",
  disabledOrange: "#FFEDB0",
  lightOrange: "#FDEAD7",
  veryLightOrange: "#FFFAEB",
  advertOrange: "#F7E7DE",
  lighterOrange: "#FFF6D6",
  orange: "#B54708",
  lightBlack: "#101828",
  lightBlack2: "#111322",
  mediumBlack: "#141414",
  white: "#FFFFFF",
  disabledRed: "#FFB8B0",
  brightBlue: "#F9FAFB",
  warning200: "#FEDF89",
  warning900: "#7A2E0E",
  warning600: "#DC6803",
  warning100: "#FEF0C7",
  yellow600: "#CA8504",
  mustardYellow: "#BFA247",
  warning300: "#FEC84B",
  warning500: "#F79009",
  bannerYellow: "#FFEBDE",

  //red
  veryLightRed: "#FFFBFA",
  lightRed: "#FEF3F2",
  lightRoseRed: "#FFF1F3",
  pinkRed: "#FEE4E2",
  pinkLightRed: "#FFF4ED",
  mediumRed: "#FDA29B",
  red: "#F04438",
  brightRed: "#D92D20",
  roseRed: "#C01048",
  darkRed: "#B42318",
  darkerRed: "#B93815",
  intenseRed: "#912018",
  error600: "#D92D20",
  error200: "#FECDCA",
  error50: "#FEF3F2",
  error700: "#B42318",
  burgundyRed: "#8C1515",
  error900: "#7A271A",
  error500: "#F04438",
  warning700: "#B54708",
  warning25: "#FFFCF5",
  deltaRed: "#e51937",
  deltaRed2: "#991125",
  deltaRedHover: "#bf152f",
  error400:"#ff4d4d",

  //green
  lightgreen: "#027A48",
  veryLightGreen: "#ECFDF3",
  success25: "#F6FEF9",
  success100: "#D1FADF",
  success700: "#027A48",
  success900: "#054F31",
  green50: "#EDFCF2",
  green200: "#AAF0C4",
  green500: "#16B364",
  green700: "#087443",
  green900: "#084C2E",
  success50: "#ECFDF3",
  success500: "#12B76A",
  success600: "#039855",

  disabledBlack: "#BBBBBB",
  yellow100: "#FEF7C3",

  //black
  black: "#000",
  lighterBlack: "#272333",

  //AM
  primary600AM: "#001E42",
  primary700AM: "#002B5C",
  amNavBackground: "#020C41",
  pink600: "#DD2590",
  amPrimaryBtn: "#0000E3",
  amPrimaryBtnHover: "#FA0073",
  amPrimaryBtnDisabled: "#9999F0",
  amSecondaryBtn: "#F2F2F0",
  amSecondaryBtnDisabled: "#F7F7F6",
  amSecondaryBtnDisabledText: "#999999",
  amNavActiveFg: "#E6006B",

  //AC
  deepBlue: "#005078",
  deeperBlue: "#003B59",
  gray950: "#0A0D12",
  darkBlack: "#1E1E1E",
  vividRed: "#FF333A",
  grayBlue100: "#EAECF5",
  gray250: "#D5D7DA",
};
